import React, {Component} from 'react';
import PokazTraseMapComponent from "./PokazTraseMapComponent";
import {TopButtonAction, TopButtonCancel} from "../../../../../componentsTopsa/buttons/TopButtons";
import DefinicjeService from "../../definicjeTras/DefinicjeService";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import PokazTraseNaMapieContainerEdycjaKoordynatowGPS from "./PokazTraseNaMapieContainerEdycjaKoordynatowGPS";
import PrzystankiService from "../../przystanki/PrzystankiService";
import {Panel} from "react-bootstrap";

export default class PokazTraseNaMapieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            przystankiNaTrasie: [],
            openPanel: false,
            pokazMarkery: true,
            czyMoznaPokazacMape: false,
            edytowanyPrzystanek: null,
            trasa:null,
        };
        this.edytujKoordynatyPrzystanku = this.edytujKoordynatyPrzystanku.bind(this)
        this.zapiszPrzystanek = this.zapiszPrzystanek.bind(this)
    }

    componentDidMount() {

        if (Boolean(this.props.trasa)) {
            this.pobierzDefinicjeTrasy(this.props.trasa.idTr)
            this.setState({trasa:this.props.trasa})
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.trasa)) {
            this.pobierzDefinicjeTrasy(nextprops.trasa.idTr)
            this.setState({trasa:nextprops.trasa})

        }
    }

    pobierzDefinicjeTrasy(trasa_id) {
        DefinicjeService.getDefinicjeWTrasie(trasa_id).then(function (response) {
            let czyPokazacMape = true;
            let arr = Array.from(response.data, item => {
                if (!(Boolean(item.szGps)) || !(Boolean(item.dlGps))) {
                    czyPokazacMape = false;
                }
                return {
                    idMi: item.idMi,
                    idPr: item.idPr,
                    nazMi: item.nazMi,
                    nazPr: item.nazPr,
                    latlng: {lat: item.szGps, lng: item.dlGps},
                    kol: item.kol
                }
            })
            this.setState({przystankiNaTrasie: arr, czyMoznaPokazacMape: czyPokazacMape})
        }.bind(this))
    }

    edytujKoordynatyPrzystanku(item) {
        PrzystankiService.getPrzystanek(item.idPr).then(function (response) {
            this.setState({edytowanyPrzystanek: response.data})
        }.bind(this))
    }

    zapiszPrzystanek(obj){
        PrzystankiService.editPrzystanek(obj.idPr,obj).then(function (response) {
            this.pobierzDefinicjeTrasy(this.state.trasa.idTr)
            this.setState({edytowanyPrzystanek:null})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <div>
                {
                    (this.state.czyMoznaPokazacMape) ?
                        <div className={'pull-right'}>
                            <TopButtonAction onClick={() => {
                                this.setState({pokazMarkery: !this.state.pokazMarkery})
                            }} text={(this.state.pokazMarkery) ? 'Ukryj markery' : 'Pokaż markery'} btnColor={'primary'} btnSize={'medium'}
                                             iconType={'fa fa-map-marker'}/>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickZamknij()
                            }} text={'Zamknij mapę'} buttonSize={'medium'}/>
                        </div>
                        :
                        <div className={'pull-right'}>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickZamknij()
                            }} text={'Zamknij listę'} buttonSize={'medium'}/>
                        </div>
                }
                {
                    Boolean(this.state.edytowanyPrzystanek) ?
                        <PokazTraseNaMapieContainerEdycjaKoordynatowGPS przystanek={this.state.edytowanyPrzystanek}
                                                                        handleClickAnuluj={() => this.setState({edytowanyPrzystanek: null})}
                                                                        handleZapiszPrzystanek={this.zapiszPrzystanek}
                        />
                        :
                        ''
                }
                </div>
                <div style={{clear:'both',height:'5px'}}></div>
                <div>
                    <Panel id="collapsible-panel-example-1" expanded={this.state.openPanel}>
                        <Panel.Heading onClick={()=>{this.setState({openPanel:!this.state.openPanel})}}>
                            <Panel.Title toggle>
                                <a>
                                {
                                    (this.state.openPanel)?
                                        <span><i className={'fa fa-eye-slash'}></i> Ukryj przystanki na trasie</span>
                                        :
                                        <span><i className={'fa fa-eye'}></i> Pokaż przystanki na trasie</span>
                                }
                                </a>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                            <Panel.Body>

                                <div>
                                    <table className={'table table-condensed'} style={{marginBottom:'0'}}>
                                        <tr style={{fontWeight:'bold'}}>
                                            <td>Lp.</td>
                                            <td>Miejscowość</td>
                                            <td>Przystanek</td>
                                            <td>Koordynaty GPS</td>
                                        </tr>
                                        {
                                            this.state.przystankiNaTrasie.map(item=>{
                                                return(
                                                    <tr style={{borderTop:'1px solid #eee', paddingTop:'3px', marginTop:'3px'}}>
                                                        <td>{item.kol}</td>
                                                        <td>{item.nazMi}</td>
                                                        <td>{item.nazPr}</td>
                                                        <td>
                                                            <span>
                                                                {Boolean(item.latlng.lat)?item.latlng.lat:'-'},
                                                                {Boolean(item.latlng.lng)?item.latlng.lng:'-'}
                                                            </span>
                                                            <span style={{fontSize:'12px',marginLeft:'15px', cursor:'pointer',color:'grey'}}
                                                                  onClick={() => {
                                                                      this.edytujKoordynatyPrzystanku(item)
                                                                  }}
                                                            >
                                                                <i className={'fa fa-pencil'}></i> Edytuj
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                </div>

                            </Panel.Body>
                        </Panel.Collapse>
                    </Panel>
                </div>
                <div>
                    {
                        (this.state.czyMoznaPokazacMape) ?
                            <PokazTraseMapComponent trasa={this.state.przystankiNaTrasie} pokazMarkery={this.state.pokazMarkery}/>
                            :
                            <TopAlertUwaga
                                text={'Nie można pokazać mapy, ponieważ nie uzupełniono wszystkich koordynatów GPS - proszę uzupełnić wartości rekordów.'}/>
                    }

                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/googleMapComponents/PokazTraseNaMapieContainer.js